import noop from 'lib/function/noop'
import { createContext, useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

interface FlightsSearchEditContextValue {
  isEditing: boolean
  openEditSearch: () => void
  closeEditSearch: () => void
}

const FlightsSearchEditContext = createContext<FlightsSearchEditContextValue>({
  isEditing: false,
  openEditSearch: noop,
  closeEditSearch: noop,
})

interface Props {
  children: React.ReactNode
}

export function FlightsSearchEditProvider({ children }: Props) {
  const { pathname } = useLocation()
  const [isEditing, setIsEditing] = useState(false)

  const openEditSearch = useCallback(() => setIsEditing(true), [])
  const closeEditSearch = useCallback(() => setIsEditing(false), [])

  useEffect(() => {
    closeEditSearch()
  }, [closeEditSearch, pathname])

  const value = useMemo(() => ({
    isEditing,
    openEditSearch,
    closeEditSearch,
  }), [closeEditSearch, isEditing, openEditSearch])

  return <FlightsSearchEditContext.Provider value={value}>
    {children}
  </FlightsSearchEditContext.Provider>
}

export default FlightsSearchEditContext
